// Use $ instead of $ without replacing global $
(function ($) {

  // tabs function
    $(document).ready(function(){
        $('body .col-three-block .col-outer .item').matchHeight();
        $('body .col-three-block .col-outer .item .content p').matchHeight();
    });

})(jQuery);